var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.063,
    height: 18.72,
    viewBox: "0 0 126.063 18.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Componente_4_1",
    "data-name": "Componente 4 \\u2013 1",
    transform: "translate(0.734 2.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_502",
    "data-name": "Trazado 502",
    d: "M2711.742,1941.352s55.688-18.424,124.448,0",
    transform: "translate(-2606.423 -2072.435) rotate(3)",
    fill: "none",
    stroke: "#f2025d",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_503",
    "data-name": "Trazado 503",
    d: "M2711.742,1941.352s55.688-18.424,124.448,0",
    transform: "translate(-2809.2 -1782.079) rotate(-3)",
    fill: "none",
    stroke: "#f2025d",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.2a25a7eecb829dc1e2cfc31cfb145fb1.svg";
export { ForwardRef as ReactComponent };